import script from "./EntitlementLogsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EntitlementLogsTable.vue?vue&type=script&setup=true&lang=js"

import "./EntitlementLogsTable.vue?vue&type=style&index=0&id=5406884a&lang=scss&scoped=true"
script.__scopeId = "data-v-5406884a"

export default script